// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col cols="12" justify-center>
        <v-card>
          <v-progress-linear v-if="loading" :indeterminate="loading" style="margin-top: 0px;"></v-progress-linear>
          <v-card-text>
            <v-row wrap>
              <v-col cols="12" md="3">
                <date-time-view
                v-model="dateStart"
                label="Start Date"
                ></date-time-view>
              </v-col>
              <v-col cols="12" md="3">
                <date-time-view
                v-model="dateEnd"
                label="End Date"
                ></date-time-view>
              </v-col>
              <v-col cols="12" md="6">
                <v-btn dark color="blue darken-1" class="mx-1" @click="resetDate()">Today</v-btn>
                <v-btn dark color="blue darken-2" class="mx-1" @click="resetWeek()">Last 7 Days</v-btn>
                <v-btn dark color="blue darken-3" class="mx-1" @click="resetMonth()">Last 30 Days</v-btn>
                <!-- <v-btn v-if="showExpButton" class="mx-1" @click="showHideAll()">{{ showHideText }}</v-btn> -->
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="getEvents()"><v-icon>refresh</v-icon></v-btn>
                  </template>
                  <span>Refresh Data</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="showGraph = !showGraph">
                      <v-icon v-if="showGraph">view_agenda</v-icon>
                      <v-icon v-else>equalizer</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="showGraph">Show Data</span>
                  <span v-else>Show Graph</span>
                </v-tooltip>
                {{ events.length }} -->
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-card v-if="items.length > 0">
      <v-card-text>
        <template v-for="(event, j) in items">
          <v-row wrap :key="j" style="border-top: 1px solid rgba(0,0,0,0.82);" dense>
            <v-col cols="12" md="3" class="font-weight-bold">
              {{ getZoneName(event.zone) }}
            </v-col>
            <v-col cols="12" md="3">
              Duration: {{ durationFormat(event.timeDuration) }}
            </v-col>
            <v-col cols="12" md="3">
              Entry: {{formatTime(event.timeStart)}}
            </v-col>
            <v-col cols="12" md="3">
              Exit: {{ formatTime(event.timeEnd) }}
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment'
import DateTimeView from './DateTimeView'
import {AXIOSAPI} from './requests-common'

export default {
  name: 'expansion-view',

  components: {
    DateTimeView
  },

  data () {
    return {
      dateStart: moment().startOf('day').format(),
      dateEnd: moment().add(1, 'days').startOf('day').format(),
      items: [],
      zones: [],
      params: {},
      url: '',
      loading: true
    }
  },

  props: {
    endpoint: null,
    site: null
  },

  created () {
    this.getEvents()
    Promise.all([
      AXIOSAPI.get('api/zones', {'params': this.$props.site})
        .then(res => {
          this.zones = res.data
        }),
    ])
  },

  watch: {
    dateStart: function () {
      this.getEvents()
    },

    dateEnd: function () {
      this.getEvents()
    }
  },

  methods: {
    compare: function (a, b) {
      var aName = a.details.common.name.toUpperCase()
      var bName = b.details.common.name.toUpperCase()
      if (aName < bName) {
        return -1
      } else if (bName < aName) {
        return 1
      }
      return 0
    },

    formatTime: function (time) {
      var m = moment(time)
      if (m.isBefore('1000-01-01')) {
        return 'N/A'
      }
      return m.format('YYYY-MM-DD' + ' hh:mm:ss a')
    },

    initializeHistory: function (endpoint) {
      return new Promise((resolve, reject) => {
        AXIOSAPI.get(endpoint)
        .then(res => {
          console.log(res.data)
          resolve(this.items = res.data)
        })
        .catch(e => {
          reject(console.err(e))
        })
      })
    },

    getEvents: function () {
      this.loading = true
      this.url = this.$props.endpoint
      this.params.thing = this.$router.app._route.params.id
      this.params.site = this.$props.site
      this.params.after = this.dateStart
      this.params.before = this.dateEnd
      Promise.all([
      AXIOSAPI.get(this.url, {'params': this.params})
        .then(res => {
          this.items = res.data
          this.loading = false
        })
      ])
    },

    getZone: function (id) {
      var zone = this.zones.find((el) => el._id === id)
      if (zone) {
        return zone
      }
      return {}
    },

    getZoneName: function (id) {
      var zone = this.getZone(id)
      if (zone) {
        return zone.name
      }
      return 'N/A'
    },

    durationFormat: function (seconds) {
      var duration = moment.duration(seconds / 1000000)
      return Math.floor(duration.as('hours')) + ':' + this.pad(duration.minutes()) + ':' + this.pad(duration.seconds())
    },

    pad: function(num) {
      if (num < 10) {
        return '0' + num
      }
      return num
    },

    resetDate: function () {
      this.dateStart = moment().startOf('day').format()
      this.dateEnd = moment().add(1, 'days').startOf('day').format()
    },

    resetWeek: function () {
      this.dateStart = moment().startOf('day').subtract(6, 'days').format()
      this.dateEnd = moment().add(1, 'days').startOf('day').format()
    },

    resetMonth: function () {
      this.dateStart = moment().startOf('day').subtract(29, 'days').format()
      this.dateEnd = moment().add(1, 'days').startOf('day').format()
    }
  }
}
</script>




// WEBPACK FOOTER //
// ExpansionView.vue?13519ae4